import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrendingUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-273.78 -348.44 1955.56 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1408 -160V-224Q1408 -237 1398.5 -246.5Q1389 -256 1376 -256H32Q19 -256 9.5 -246.5Q0 -237 0 -224V-160Q0 -147 9.5 -137.5Q19 -128 32 -128H1376Q1389 -128 1398.5 -137.5Q1408 -147 1408 -160ZM1152 896Q1152 818 1127.5 752.0Q1103 686 1063.5 639.5Q1024 593 976.0 551.5Q928 510 880.0 474.0Q832 438 792.5 402.0Q753 366 728.5 320.5Q704 275 704 224Q704 128 771 0L767 1L768 0Q678 41 608.0 83.0Q538 125 469.5 183.0Q401 241 356.0 305.5Q311 370 283.5 456.0Q256 542 256 640Q256 718 280.5 784.0Q305 850 344.5 896.5Q384 943 432.0 984.5Q480 1026 528.0 1062.0Q576 1098 615.5 1134.0Q655 1170 679.5 1215.5Q704 1261 704 1312Q704 1406 638 1536L641 1535L640 1536Q730 1495 800.0 1453.0Q870 1411 938.5 1353.0Q1007 1295 1052.0 1230.5Q1097 1166 1124.5 1080.0Q1152 994 1152 896Z"
	})
});
export default SvgTrendingUp;
